import React, { useContext } from "react";
import { NavLink, Outlet } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";

function Avatar({ name, size = 36 }) {
  const initials = (name || "??")
    .split(" ")
    .map((s) => s[0])
    .slice(0, 2)
    .join("")
    .toUpperCase();

  return (
    <div
      style={{
        width: size,
        height: size,
        borderRadius: 10,
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        background:
          "linear-gradient(135deg, rgba(47,199,255,0.25), rgba(111,184,255,0.2))",
        fontWeight: 800,
        color: "#021322",
      }}
    >
      {initials}
    </div>
  );
}

export default function AppLayout() {
  const { user, logout } = useContext(AuthContext);

  return (
    <div
      style={{
        minHeight: "100vh",
        background: "radial-gradient(circle at top,#032648,#000814)",
        color: "#eaf6ff",
        display: "flex",
      }}
    >
      {/* Sidebar */}
      <div
        style={{
          width: 240,
          background: "linear-gradient(180deg,#021325,#030814)",
          borderRight: "1px solid rgba(255,255,255,0.08)",
          padding: "16px 12px",
          display: "flex",
          flexDirection: "column",
          gap: 12,
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 10 }}>
          <Avatar name={user?.name || ""} />
          <div>
            <div style={{ fontWeight: 700, fontSize: 15 }}>{user?.name}</div>
            <div style={{ fontSize: 12, color: "#8ecbff" }}>{user?.location}</div>
          </div>
        </div>

        <div style={{ fontSize: 11, color: "#7aa7ff", textTransform: "uppercase", letterSpacing: 1 }}>
          Navigation
        </div>

        <NavLink
          to="/app/overview"
          className="nav-link"
          style={({ isActive }) => ({
            padding: "8px 10px",
            borderRadius: 8,
            marginBottom: 4,
            fontSize: 14,
            background: isActive ? "rgba(47,199,255,0.10)" : "transparent",
            color: isActive ? "#eaf6ff" : "#a9c7ff",
            textDecoration: "none",
          })}
        >
          🏠 Overview
        </NavLink>

        <NavLink
          to="/app/my-certs"
          className="nav-link"
          style={({ isActive }) => ({
            padding: "8px 10px",
            borderRadius: 8,
            marginBottom: 4,
            fontSize: 14,
            background: isActive ? "rgba(47,199,255,0.10)" : "transparent",
            color: isActive ? "#eaf6ff" : "#a9c7ff",
            textDecoration: "none",
          })}
        >
          🎓 My Certifications
        </NavLink>
        <NavLink
          to="/app/org-dashboard"
          className="nav-link"
          style={({ isActive }) => ({
            padding: "8px 10px",
            borderRadius: 8,
            marginBottom: 4,
            fontSize: 14,
            background: isActive ? "rgba(47,199,255,0.10)" : "transparent",
            color: isActive ? "#eaf6ff" : "#a9c7ff",
            textDecoration: "none",
          })}
        >
          📊 Org Dashboard
        </NavLink>

        <NavLink
          to="/app/leaderboard"
          className="nav-link"
          style={({ isActive }) => ({
            padding: "8px 10px",
            borderRadius: 8,
            marginBottom: 4,
            fontSize: 14,
            background: isActive ? "rgba(47,199,255,0.10)" : "transparent",
            color: isActive ? "#eaf6ff" : "#a9c7ff",
            textDecoration: "none",
          })}
        >
          🏆 Leaderboard
        </NavLink>

        <NavLink
          to="/app/quiz"
          className="nav-link"
          style={({ isActive }) => ({
            padding: "8px 10px",
            borderRadius: 8,
            marginBottom: 4,
            fontSize: 14,
            background: isActive ? "rgba(47,199,255,0.10)" : "transparent",
            color: isActive ? "#eaf6ff" : "#a9c7ff",
            textDecoration: "none",
          })}
        >
          🧠 Quiz Arena
        </NavLink>

        <div style={{ flexGrow: 1 }} />

        <button
          className="btn btn-sm btn-outline-light"
          onClick={logout}
          style={{ width: "100%", borderRadius: 999 }}
        >
          Logout
        </button>
      </div>

      {/* Main content */}
      {/* <div style={{ flex: 1, padding: "16px 24px" }}> */}
      <div
        style={{
          flex: 1,
          padding: "16px 24px",
          background: "rgba(3,19,40,0.96)",
          minHeight: "100vh",
        }}
      >
        <header
          className="d-flex justify-content-between align-items-center mb-3"
          style={{ borderBottom: "1px solid rgba(255,255,255,0.08)", paddingBottom: 8 }}
        >
          <div>
            <div style={{ fontSize: 22, fontWeight: 700, color: "#d6f4ff" }}>
              Presidio — AI Certification Quest
            </div>
          </div>
        </header>

        <main style={{ width: "100%", maxWidth: "100%", display: "block" }}>
          <Outlet />
        </main>
      </div>
    </div>
  );
}
